import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import * as ReportServices from "../../../../services/ReportService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ButtonAction, Icon } from "./reportList.styled";
import { AbilityContext } from "../../../security/permissions/Can";
import {} from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import showDialog from "../../../utils/ShowDialog/ShowDialog";

// import {
//   ShowAlertDialog,
//   PaginateList,
// } from "@de-prado-dev/react-component-library";

import PaginateList from "../../../utils/PaginateList";
import { DEPARTMENTS } from "../../../../constants";
import PATHS from "../../../../constants/paths";

const FormListContainer = ({ filters, sortBy, year, department }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [skills, setSkills] = useState(false);

  const columns = [
    {
      header: t("forms.report.table.heads.department"),
      accessorKey: "department",
      cell: (info) => {
        const department = DEPARTMENTS.find(
          (type) => type.code === "" + info.getValue(),
        );

        return t(department.label);
      },
    },
    {
      header: t("forms.report.table.heads.year"),
      accessorKey: "year",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.report.table.heads.numEvaluations"),
      accessorKey: "numEvaluations",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.report.table.heads.averageGoals"),
      accessorKey: "averageGoals",
      cell: (info) => Math.round(info.getValue() * 100) / 100,
    },
    {
      header: t("forms.report.table.heads.averageCompetencies"),
      accessorKey: "averageCompetencies",
      cell: (info) => Math.round(info.getValue() * 100) / 100,
    },
    {
      header: t("forms.report.table.heads.averageFinal"),
      accessorKey: "averageFinal",
      cell: (info) => Math.round(info.getValue() * 100) / 100,
    },
    {
      Header: t(" "),
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const goToEdit = (uuid) => {
    navigate(PATHS.EDIT_REPORT.replace(":uuid", uuid));
  };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction onClick={() => goToEdit(data.uuid)} type="button">
          <i className="fa-regular fa-pen-to-square"></i>
        </ButtonAction>
        <ButtonAction
          onClick={() => showDialogOnDelete(data.uuid)}
          type="button"
        >
          <Icon className="fa-solid fa-trash-can"></Icon>
        </ButtonAction>
        <ButtonAction
          onClick={() =>
            navigate(PATHS.VIEW_REPORT.replace(":uuid", data.uuid))
          }
          type="button"
        >
          <i className="fa-regular fa-eye"></i>
        </ButtonAction>
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    let title;
    let text;
    let icon;
    const okAction = async () => {
      ReportServices.deleteReport(uuid).then((result) => {
        if (result) {
          title = t("forms.report.messages.remove.title");
          text = t("forms.report.messages.remove.success");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.report.messages.update.error");
          icon = "error";
        }
        let okAction = () => {
          setForceRefresh(true);
          navigate(PATHS.CONFIG);
        };
        showDialog(title, text, icon, false, "OK", false, okAction);
      });
    };

    const cancelAction = () => {};

    showDialog(
      t("forms.report.dialog.remove.title"),
      t("forms.report.dialog.remove.text"),
      "warning",
      true,
      t("forms.report.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.report.dialog.remove.buttonNo"),
      cancelAction,
    );
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-date";
    }

    const result = await ReportServices.listFilter(filter);
    setSkills(result.skills);
    return result.data;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

FormListContainer.propTypes = {
  filters: PropTypes.object,
};

export default FormListContainer;
